import { useCallback, useMemo } from 'react';

import { useAppDispatch, useAppSelector } from '@app/store/hooks';
import { resetAuth, setAuth } from '@entities/auth/model/auth-slice';
import { selectAuthUser, selectIsAuthorized } from '@entities/auth/model/selectors';
import type { AuthUser } from '@entities/auth/model/types';

export const useAuth = () => {
	const dispatch = useAppDispatch();
	const isAuthorized = useAppSelector(selectIsAuthorized);
	const user = useAppSelector(selectAuthUser);

	const setAuthCb = useCallback((authUser: AuthUser) => dispatch(setAuth(authUser)), [dispatch]);
	const resetAuthCb = useCallback(() => dispatch(resetAuth()), [dispatch]);

	return useMemo(
		() => ({
			isAuthorized,
			user,
			setAuth: setAuthCb,
			resetAuth: resetAuthCb,
		}),
		[isAuthorized, resetAuthCb, setAuthCb, user]
	);
};
